<template>
    <div :style="'height: 100vh;background-image: linear-gradient(0deg,' + $bgColor + '0%,' + $bgColor2 + '100%)'">
      <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:svgjs="http://svgjs.dev/svgjs" :width="width" :height="heigthScreen + 100" preserveAspectRatio="none" viewBox="0 0 1440 1400">
          <g mask="url(&quot;#SvgjsMask1022&quot;)" fill="none">
              <rect width="1440" height="1400" x="0" y="0" fill="url(&quot;#SvgjsLinearGradient1023&quot;)"></rect>
              <path d="M0 0L524.4 0L0 519.63z" fill="rgba(255, 255, 255, .2)"></path>
              <path d="M0 519.63L524.4 0L834.93 0L0 903.51z" fill="rgba(255, 255, 255, .1)"></path>
              <path d="M0 903.51L834.93 0L911.0699999999999 0L0 1162.46z" fill="rgba(255, 255, 255, .1)"></path>
              <path d="M0 1162.46L911.0699999999999 0L1026.9199999999998 0L0 1316.97z" fill="rgba(255, 255, 255, .025)"></path>
              <path d="M1440 1400L1288.49 1400L1440 969.5699999999999z" fill="rgba(0, 0, 0, .1)"></path>
              <path d="M1440 969.5699999999999L1288.49 1400L670.45 1400L1440 956.0799999999999z" fill="rgba(0, 0, 0, .095)"></path>
              <path d="M1440 956.0799999999999L670.45 1400L299.99000000000007 1400L1440 891.93z" fill="rgba(0, 0, 0, .07)"></path>
              <path d="M1440 891.93L299.99 1400L242.81 1400L1440 723.64z" fill="rgba(0, 0, 0, .025)"></path>
          </g>
          <defs>
              <mask id="SvgjsMask1022">
                  <rect width="1440" height="1400" fill="#ffffff"></rect>
              </mask>
              <linearGradient x1="0.69%" y1="-0.71%" x2="99.31%" y2="100.71%" gradientUnits="userSpaceOnUse" id="SvgjsLinearGradient1023">
                  <stop :stop-color="$bgColor" offset="0"></stop>
                  <stop :stop-color="$bgColor2" offset="1"></stop>
              </linearGradient>
          </defs>
      </svg>
      <v-container style="top: 26px;position: absolute;">
        <div style="text-align: end;margin-bottom: 20px">
        <v-chip class="mr-2" @click="changlangue('th')">
          <v-avatar left>
            <v-img :src="thai"></v-img>
          </v-avatar>
            TH
        </v-chip>
        <v-chip class="mr-2" @click="changlangue('en')">
          <v-avatar left>
            <v-img :src="eng"></v-img>
          </v-avatar>
            EN
        </v-chip>
      </div>
        <!-- <div v-show="loginTel !== true">
          <p style="text-align: center;color: white">{{ $t("message.loginAccount") }}</p>
          <v-row style="text-align: center;">
            <v-col>
              <v-btn style="width: 75%;" @click="regisBytel()">
                <v-avatar left size="25" class="mr-1">
                  <img
                    :src="shopTheme.logo"
                    alt="John"
                  >
                </v-avatar>{{ $t("message.login") }}</v-btn>
            </v-col>
          </v-row>
        </div> -->
        <v-card class="pa-4 py-6" v-show="loginTel" style="border-radius: 20px !important">
        <div style="text-align: center;">
          <div style="text-align: end;">
            <!-- <v-btn rounded class="mb-2" small @click="loginTel = false"><v-icon class="mr-2">mdi-arrow-left-circle</v-icon>{{ $t("message.back") }}</v-btn> -->
          </div>
          <v-form v-model="validAdd" lazy-validation>
            <div class="mb-5" style="transform: rotate(356deg);justify-content: center;display: flex;">
              <v-img
                max-width="250"
                contain
                :src="shopId === 'U97dd281445cde30a599a5f5515a4e937' ? 'https://storage.googleapis.com/betask-loyalty.appspot.com/static/upload/reward/REWARD3383_20231122153847305071.png' : ''"
              ></v-img>
              <!-- <img
                v-if="shopTheme"
                alt="John"
              > -->
              </div>
            <div class="mb-1"><h3 class="mb-0">{{ $t("message.loginToMember") }}</h3></div>
            <div class="mb-0"><h4 style="color: #c1061a;font-weight: 600;">{{shopId === 'U97dd281445cde30a599a5f5515a4e937' ? 'Magic gift card' : 'บัตรสมาชิก'}}</h4></div>
            <div class="mb-5">{{ $t("message.forCheckPoint") }}</div>
            <v-text-field
              :rules="[rules.counterTel]"
              v-model="tel"
              outlined
              prepend-inner-icon="mdi-cellphone"
              :label="this.$t('message.fillTel')"
            ></v-text-field>
            <v-btn class="mt-2" style="width: 95%;color: white !important" @click="checkIsmember" :disabled="!validAdd || !tel" :loading="loadingBtn" color="green">
              {{ $t("message.login") }}
            </v-btn>
          </v-form>
        </div>
      </v-card>
      <!-- <div style="text-align: center;margin-top: 20px">
        <v-chip class="mr-2" @click="changlangue('th')">
          <v-avatar left>
            <v-img :src="thai"></v-img>
          </v-avatar>
            TH
        </v-chip>
        <v-chip class="mr-2" @click="changlangue('en')">
          <v-avatar left>
            <v-img :src="eng"></v-img>
          </v-avatar>
            EN
        </v-chip>
      </div> -->
      </v-container>
      <!-- dialog reset Otp -->
      <v-dialog
        transition="dialog-bottom-transition"
        max-width="600"
        v-model="dialogResetOTP"
        persistent>
          <v-card>
            <v-toolbar
              :color="$bgColor2"
              dark
            ><div>{{ $t("message.resetOtpPin") }}</div><v-spacer></v-spacer><v-icon @click="dialogResetOTP = false, loadingbtn = false">mdi-close</v-icon></v-toolbar>
            <v-card-text class="text-h2 px-5" style="font-family: Kanit !important;">
              <p style="font-size: 15px;height: 33px;padding-left: 10px;" class="mb-0">{{ $t("message.waiting") }}</p>
              <div class="pa-1" style="display:flex;font-size: 15px"> <v-icon>mdi-cellphone-key</v-icon><p class="mb-0 mr-3">{{ $t("message.otpSentTo") }} </p> <p class="mb-0">{{ this.tel }}</p></div>
              <v-text-field
                v-model="otpPassword"
                class="mt-5"
                :label="`${this.$t('message.enterOtp')}`"
                maxlength="4"
              ></v-text-field>
            </v-card-text>
            <v-card-actions class="justify-end">
              <v-btn
                color="success"
                @click="otpCheck"
              >{{ $t("message.confirm") }}</v-btn>
              <!-- <v-btn
                color="error"
                @click="dialogOTP = false"
              >ปิด</v-btn> -->
            </v-card-actions>
          </v-card>
      </v-dialog>
      <!-- dialog reset Otp -->
      <!-- dialog reset pin -->
    <v-dialog
      v-model="dialogResetPin"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition">
      <v-card>
        <v-overlay :value="overlay">
          <v-progress-circular
            indeterminate
            size="64"
          ></v-progress-circular>
        </v-overlay>
        <div style="text-align: end;padding:10px">
            <!-- <v-btn rounded class="mb-2" small @click="dialogPin = false, loadingBtn = false"><v-icon class="mr-2">mdi-arrow-left-circle</v-icon>{{ $t("message.back") }}</v-btn> -->
        </div>
        <v-list
          three-line
          subheader
          style="padding: 20px;display: flex;justify-content: center;padding-bottom: 15px;padding-top: 5px"
        >
          <div style="text-align: center">
            <v-avatar left size="85">
              <v-icon style="font-size: 50px;">mdi-lock-reset</v-icon>
            </v-avatar>
            <v-subheader style="font-size:16px">{{ $t("message.resetPin") }}</v-subheader>
          </div>
          <!-- <v-list-item>
            <v-list-item-content>
              <v-list-item-title>Content filtering</v-list-item-title>
              <v-list-item-subtitle>Set the content filtering level to restrict apps that can be downloaded</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>Password</v-list-item-title>
              <v-list-item-subtitle>Require password for purchase or use password to restrict purchase</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item> -->
        </v-list>
        <div class=" mb-0 px-4" style="color: #8f8c8c;font-weight: bold;display:flex"><p class="mb-0" style="color:red">**** </p>{{ $t("message.resetPinMessage") }}</div>
          <div>
            <v-col
              cols="12"
              sm="6"
            >
              <v-text-field
                v-model="newPin"
                type="number"
                counter="6"
                outlined
                dense
                :label="`${this.$t('message.newPin')} `"
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              sm="6"
            >
              <v-text-field
                v-model="newPinConfirm"
                type="number"
                counter="6"
                v-mask="'######'"
                outlined
                dense
                :label="`${this.$t('message.confirmNewPin')} `"
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              sm="6"
            >
            <v-btn @click="changeNewPin" color="orange" style="color: white !important" block :disabled="newPinConfirm !==  newPin || newPin.length < 6 || newPin.length > 6 || newPinConfirm.length < 6 || newPinConfirm.length > 6 || newPinConfirm === '' || newPin === ''">
              {{ $t("message.changePin") }}
            </v-btn>
            </v-col>
          </div>
        <!-- <div style="display: flex;justify-content: center;">
            <div class="mr-4" :style="'width: 9px;border-radius: 111px;padding: 11px;background-color:' + count1() + 'border: solid 2px grey;'"></div>
            <div class="mr-4" :style="'width: 9px;border-radius: 111px;padding: 11px;background-color:' + count2() + 'border: solid 2px grey;'"></div>
            <div class="mr-4" :style="'width: 9px;border-radius: 111px;padding: 11px;background-color:' + count3() + 'border: solid 2px grey;'"></div>
            <div class="mr-4" :style="'width: 9px;border-radius: 111px;padding: 11px;background-color:' + count4() + 'border: solid 2px grey;'"></div>
            <div class="mr-4" :style="'width: 9px;border-radius: 111px;padding: 11px;background-color:' + count5() + 'border: solid 2px grey;'"></div>
            <div :style="'width: 9px;border-radius: 111px;padding: 11px;background-color:' + count6() + 'border: solid 2px grey;'"></div>
        </div> -->
        <!-- <v-divider></v-divider> -->
      </v-card>
    </v-dialog>
    <!-- dialog reset pin -->
      <v-dialog
      v-model="dialogPin"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition">
      <v-card>
        <v-overlay :value="overlay">
          <v-progress-circular
            indeterminate
            size="64"
          ></v-progress-circular>
        </v-overlay>
        <div style="text-align: end;padding:10px">
            <v-btn rounded class="mb-2" small @click="dialogPin = false"><v-icon class="mr-2">mdi-arrow-left-circle</v-icon>{{ $t("message.back") }}</v-btn>
        </div>
        <v-list
          three-line
          subheader
          style="padding: 20px;display: flex;justify-content: center;padding-bottom: 15px;padding-top: 5px"
        >
          <div style="text-align: center">
            <v-avatar left>
              <v-img :src="require('@/assets/padlock.png')"></v-img>
            </v-avatar>
            <v-subheader style="font-size:16px">{{ $t("message.confirmPin") }}</v-subheader>
          </div>
          <!-- <v-list-item>
            <v-list-item-content>
              <v-list-item-title>Content filtering</v-list-item-title>
              <v-list-item-subtitle>Set the content filtering level to restrict apps that can be downloaded</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>Password</v-list-item-title>
              <v-list-item-subtitle>Require password for purchase or use password to restrict purchase</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item> -->
        </v-list>
        <div style="display: flex;justify-content: center;">
            <div class="mr-4" :style="'width: 9px;border-radius: 111px;padding: 11px;background-color:' + count1() + 'border: solid 2px grey;'"></div>
            <div class="mr-4" :style="'width: 9px;border-radius: 111px;padding: 11px;background-color:' + count2() + 'border: solid 2px grey;'"></div>
            <div class="mr-4" :style="'width: 9px;border-radius: 111px;padding: 11px;background-color:' + count3() + 'border: solid 2px grey;'"></div>
            <div class="mr-4" :style="'width: 9px;border-radius: 111px;padding: 11px;background-color:' + count4() + 'border: solid 2px grey;'"></div>
            <div class="mr-4" :style="'width: 9px;border-radius: 111px;padding: 11px;background-color:' + count5() + 'border: solid 2px grey;'"></div>
            <div :style="'width: 9px;border-radius: 111px;padding: 11px;background-color:' + count6() + 'border: solid 2px grey;'"></div>
          </div>
          <div v-if="shopId !== 'U43e7e7332135fa3253d4a1385a8a89ce'" style="text-align: center;margin-top: 25px;text-decoration: underline" @click="createOtp">{{ $t("message.forgotPin") }}</div>
        <!-- <v-divider></v-divider> -->
        <v-list
          three-line
          subheader
          style="margin-top: 70px;"
        >
        <div style="display: flex;justify-content: space-between;" class="mb-6">
            <div cols="4" class="text-center" style="padding-left: 60px">
              <v-avatar style="border:solid grey !important" color="white" size="62" @click="inputPin('1')">
                <span class="black--text text-h5">1</span>
              </v-avatar>
            </div>
            <div cols="4" class="text-center">
              <v-avatar style="border:solid grey !important" color="white" size="62" @click="inputPin('2')">
                <span class="black--text text-h5">2</span>
              </v-avatar>
            </div>
            <div cols="4" class="text-center" style="padding-right: 60px">
              <v-avatar style="border:solid grey !important" color="white" size="62" @click="inputPin('3')">
                <span class="black--text text-h5">3</span>
              </v-avatar>
            </div>
          </div>
          <div style="display: flex;justify-content: space-between;" class="mb-6">
            <div cols="4" class="text-center" style="padding-left: 60px">
              <v-avatar style="border:solid grey !important" color="white" size="62" @click="inputPin('4')">
                <span class="black--text text-h5">4</span>
              </v-avatar>
            </div>
            <div cols="4" class="text-center">
              <v-avatar style="border:solid grey !important" color="white" size="62" @click="inputPin('5')">
                <span class="black--text text-h5">5</span>
              </v-avatar>
            </div>
            <div cols="4" class="text-center" style="padding-right: 60px">
              <v-avatar style="border:solid grey !important" color="white" size="62" @click="inputPin('6')">
                <span class="black--text text-h5">6</span>
              </v-avatar>
            </div>
          </div>
          <div style="display: flex;justify-content: space-between;" class="mb-6">
            <div cols="4" class="text-center" style="padding-left: 60px">
              <v-avatar style="border:solid grey !important" color="white" size="62" @click="inputPin('7')">
                <span class="black--text text-h5">7</span>
              </v-avatar>
            </div>
            <div cols="4" class="text-center">
              <v-avatar style="border:solid grey !important" color="white" size="62" @click="inputPin('8')">
                <span class="black--text text-h5">8</span>
              </v-avatar>
            </div>
            <div cols="4" class="text-center" style="padding-right: 60px">
              <v-avatar style="border:solid grey !important" color="white" size="62" @click="inputPin('9')">
                <span class="black--text text-h5">9</span>
              </v-avatar>
            </div>
          </div>
          <div style="display: flex;justify-content: space-between;" class="mb-6">
            <div cols="4" class="text-center" style="padding-left: 60px">
              <v-avatar color="white" size="62">
                <span class="black--text text-h5"></span>
              </v-avatar>
            </div>
            <div cols="4" class="text-center">
              <v-avatar style="border:solid grey !important" color="white" size="62" @click="inputPin('0')">
                <span class="black--text text-h5">0</span>
              </v-avatar>
            </div>
            <div cols="4" class="text-center" style="padding-right: 60px">
              <v-avatar style="border:solid grey !important" color="white" size="62" @click="deletePin()">
                <span class="black--text text-h5"><v-icon size="32">mdi-backspace</v-icon></span>
              </v-avatar>
            </div>
          </div>
        </v-list>
      </v-card>
    </v-dialog>
    </div>
 </template>
<script>
import { mapActions, mapGetters } from 'vuex'
import Swal from 'sweetalert2'
import axios from 'axios'
export default {
  name: 'Login',
  data () {
    return {
      title: 'คุณยังไม่เป็นสมาชิก ต้องการสมัครสมาชิก ใช่หรือไม่ ?',
      shopId: null,
      tel: null,
      loginTel: true,
      dialogPin: false,
      pin_number: '',
      otpPassword: '',
      dataMember: null,
      overlay: false,
      thai: 'https://firebasestorage.googleapis.com/v0/b/betask-linked/o/picture-web%2Fflag-TH.png?alt=media&token=e4bd7ffa-aed9-47e3-9240-4dcb9d8d284e',
      eng: 'https://firebasestorage.googleapis.com/v0/b/betask-linked/o/picture-web%2Fflag-USA1.png?alt=media&token=a83dd820-f576-457a-8d08-1009cea9d70b',
      validAdd: true,
      loadingBtn: false,
      memberStore: null,
      dialogResetOTP: false,
      dialogResetPin: false,
      newPinConfirm: '',
      newPin: '',
      shopTheme: null,
      heigthScreen: null,
      width: null,
      rules: {
        numberRules: (value) =>
          (!isNaN(parseFloat(value)) && value >= 0 && value <= 9999999999) ||
          'กรุณากรอกตัวเลข 0 ถึง 9',
        counterTel: (value) => value.length === 10 || 'Max 10 characters',
        IDcardRules: (value) =>
          (!isNaN(parseFloat(value)) && value >= 0 && value <= 9999999999999) ||
          'กรุณากรอกตัวเลข 0 ถึง 9',
        required: (value) => !!value || 'กรุณากรอก.',
        counterIDcard: (value) => value.length <= 13 || 'Max 13 characters',
        email: (value) => {
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid e-mail.'
        }
      }
    }
  },
  // eslint-disable-next-line space-before-function-paren
  async mounted () {
    this.shopId = this.GET_SHOPID()
    this.memberStore = this.GET_MEMBERINFO()
    this.shopTheme = this.GET_THEME()
    this.heigthScreen = window.innerHeight
    this.width = window.width
    // if (this.$route.query.shopId !== this.memberStore.shopId) {
    //   this.setNullMemberInfo()
    // } else {
    //   this.dialogPin = true
    // }
    // this.$route.query.shopId
  },
  methods: {
    ...mapActions('lineStore', ['setProfile']),
    ...mapActions('memberStore', ['setNullMemberInfo']),
    ...mapGetters('lineStore', ['liffIsReady', 'getLiffProfile']),
    ...mapGetters('memberStore', ['GET_MEMBERINFO']),
    ...mapGetters('shopStore', ['GET_SHOPID', 'GET_THEME']),
    ...mapActions('shopStore', ['getShopTheme', 'getShoppLevel']),

    regisByLine () {

    },
    async checkLiffLogin () {
      await this.checkLiffState()
      try {
        this.$liff.init({
          liffId: this.$liffId
          // withLoginOnExternalBrowser: true
        }).then(async () => {
          await this.getProfileMain()
          await this.setProfile(this.profile)
          await this.updateProfile()
          await this.checkLostData()
          await this.checkWelcome()
          // this.$i18n.locale = this.member.language
          this.loaded = true
          if (this.member.language) {
            this.$i18n.locale = this.member.language
          }
          this.$showHome = true
          // await this.testGetLiffbyAnotherliffID()
        }).catch((err) => {
          console.error(err.code, err.message)
          // alert(err.message)
        })
        // alert('finisdhInit2')
      } catch (err) {
        console.error(err)
      }
    },
    async checkWelcome () {
      try {
        this.member = this.GET_MEMBERINFO()
        this.shopId = this.GET_SHOPID()
        this.member === null ? this.findUser = false : this.findUser = true
        if (this.$route.query.type === 'welcome') {
          if (this.findUser) {
            await axios.get(this.DNS_IP + '/member/get?shopId=' + this.$route.query.shopId + '&liffUserId=' + this.profile.userId).then(async result => {
              if (typeof result.data.status === 'undefined') {
                this.lineUserIds = result.data[0].lineUserId || ''
                this.liffUserIds = result.data[0].liffUserId || ''
                this.memberId = result.data[0].memberId
              } else {
                this.$router.push(`/RegisterMember?shopId=${this.$route.query.shopId}&memberId=${this.member.memberId}`)
              }
              if (this.lineUserIds === '' && this.liffUserIds !== '') { // check empty lineUserId (modular)
                if (this.$liff.isInClient()) {
                  this.$liff.sendMessages([
                    {
                      type: 'text',
                      text: 'เปิดใช้งานบัตรสะสมแต้มเรียบร้อย หมายเลขสมาชิกของคุณคือ ' + this.memberId
                    }
                  ])
                    .then(() => {
                    })
                    .catch((err) => {
                      console.error('error', err)
                    })
                } else {
                  console.error('ไม่เข้า')
                }
              }
            })
          } else if (!this.findUser) {
            this.$router.push(`/RegisterMember?shopId=${this.$route.query.shopId}`)
          }
        }
      } catch (err) {
        console.error(err)
      }
    },
    async checkLostData () {
      try {
        this.member = await this.callBeTaskAPI('get', '/memberCard/line/get?shopId=' + this.shopId + '&liffUserId=' + this.profile.userId)
        // console.log('app.vue', this.member[0].memberId)
        this.shopId = this.GET_SHOPID()
        const currentUrl = window.location.pathname
        if (currentUrl !== '/PrivacyNotice') {
          this.member.status === false ? this.findUser = false : this.findUser = true
          // console.log('app.vue', this.member.status)
          // console.log('app.vueeee', !this.findUser && this.$route.query.shopId)
          this.dataMember = await this.callBeTaskAPI('get', '/member/get?shopId=' + this.$route.query.shopId + '&liffUserId=' + this.profile.userId)
          if (!this.$route.query.type && !this.$route.query.likeToken && !this.$route.query.packageToken && !this.$route.query.token) {
            if (!this.findUser && this.$route.query.shopId && currentUrl !== '/RegisterMember') {
              const redirectUrl = encodeURIComponent(currentUrl + window.location.search)
              this.$router.push(`/RegisterMember?shopId=${this.$route.query.shopId}&type=anotherlink&redirectUrl=${redirectUrl}`)
            }
            if (this.findUser && Array.isArray(this.dataMember) === false && this.$route.query.shopId) { // เช็คว่าามี membercard เเต่ไม่มี member
              const redirectUrl = encodeURIComponent(currentUrl + window.location.search)
              this.$router.push(`/RegisterMember?shopId=${this.$route.query.shopId}&memberId=${this.member[0].memberId}&redirectUrl=${redirectUrl}`)
            }
          }
        }
      } catch (err) {
        console.error(err)
      }
    },
    async getProfileMain () {
      // alert('getProfileMain')
      try {
        await this.$liff.ready.then(async () => {
          // alert('$liff.ready')
          if (process.env.NODE_ENV === 'development') {
            this.getProfile_dev()
          } else {
            if (!this.$liff.isLoggedIn()) {
              // alert('!this.$liff.isLoggedIn()')
              await this.$liff.login({redirectUri: window.location.href})
            } else {
              // alert('getProfile')
              await this.getProfile()
              // if (this.$route.query['liff.state']) {
              //   this.$router.push(this.$route.query['liff.state'])
              // }
            }
          }
        })
      } catch (err) {
        console.error(err)
      }
    },
    async getProfile () {
      try {
        let _this = this
        await this.$liff.getProfile().then(function (profile) {
          // alert(profile)
          profile.pictureUrl = profile.pictureUrl || 'https://firebasestorage.googleapis.com/v0/b/betask-loyalty.appspot.com/o/user.png?alt=media&token=b9e270ee-8367-489f-8693-03499508dcd2'
          _this.profile = profile
        }).catch(function (error) {
          console.error('Error getting profile: ' + error)
        })
      } catch (err) {
        console.error(err)
      }
    },
    getProfile_dev () {
      this.profile = this.$profile_dev
      this.profile.pictureUrl = this.profile.pictureUrl || 'https://firebasestorage.googleapis.com/v0/b/betask-loyalty.appspot.com/o/user.png?alt=media&token=b9e270ee-8367-489f-8693-03499508dcd2'
    },
    async updateProfile () {
      try {
        this.member = this.GET_MEMBERINFO()
        if (typeof this.member.memberId !== 'undefined') {
          await axios.post(this.DNS_IP + `member/edit/${this.member.memberId}`, {name: this.profile.displayName.replace(/'/g, "\\'"), picture: this.profile.pictureUrl})
          // this.callBeTaskAPI('post', `/member/edit/${this.member.memberId}`, {name: this.profile.displayName, picture: this.profile.pictureUrl})
        }
      } catch (err) {
        console.error(err)
      }
    },
    regisBytel () {
      this.loginTel = true
      // this.$router.push(`/RegisterMember?shopId=${this.$route.query.shopId}`)
    },
    changlangue (lang) {
      this.$i18n.locale = lang
    },
    async checkIsmember () {
      // console.log('checkIsmember')
      this.loadingBtn = true
      await axios
        .get(
          this.DNS_IP + '/member/get?shopId=' +
          this.$route.query.shopId +
          '&tel=' + this.tel
        )
        .then(async (result) => {
          if (result.data.status === undefined) {
            this.dataMember = result.data[0]
            this.dialogPin = true
            this.loadingBtn = false
            // this.profile.tel = this.tel
            // this.profile.memberId = result.data[0].memberId
            // this.profile.userId = result.data[0].liffUserId || ''
            // this.profile.displayName = result.data[0].name || result.data[0].nameCustomer
            // this.profile.pictureUrl = result.data[0].picture || null
            // this.profile.memberCardId = result.data[0].memberCardId || null
            // await this.setProfile(this.profile)
            // this.$router.push('/home?shopId=' + this.shopId)
          } else {
            Swal.fire({
              title: '<h5>' + this.$t('message.notMemberAndRegis') + '</h5>',
              showCancelButton: true,
              allowOutsideClick: false,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#b3b1ab',
              confirmButtonText: `${this.$t('message.regisMember')}`,
              cancelButtonText: `${this.$t('message.cancle')}`
            }).then(async (confirm) => {
              if (confirm.isConfirmed) {
                let res = await axios.get(this.DNS_IP + '/importData/line/get?shopId=' + this.shopId + '&tel=' + this.tel)
                if (Array.isArray(res.data)) {
                  sessionStorage.setItem('info', JSON.stringify(res.data[0]))
                  this.profile.tel = this.tel
                  await this.setProfile(this.profile)
                  this.$router.push(`/RegisterMember?shopId=${this.$route.query.shopId}&tel=${this.tel}&importData=true`)
                } else {
                  this.profile.tel = this.tel
                  await this.setProfile(this.profile)
                  this.$router.push(`/RegisterMember?shopId=${this.$route.query.shopId}&tel=${this.tel}`)
                }
              } else {
                this.loadingBtn = false
              }
            })
            // this.statusBelink = false
          }
        })
    },
    logInfromPin () {
    },
    count1 () {
      return this.pin_number.length > 0 ? '#349aff;' : 'white;'
    },
    count2 () {
      return this.pin_number.length >= 2 ? '#349aff;' : 'white;'
    },
    count3 () {
      return this.pin_number.length >= 3 ? '#349aff;' : 'white;'
    },
    count4 () {
      return this.pin_number.length >= 4 ? '#349aff;' : 'white;'
    },
    count5 () {
      return this.pin_number.length >= 5 ? '#349aff;' : 'white;'
    },
    count6 () {
      return this.pin_number.length >= 6 ? '#349aff;' : 'white;'
    },
    async inputPin (num) {
      if (this.pin_number.length > 6) {
        // console.log('เกิน')
      } else {
        this.pin_number = this.pin_number + num
        if (this.pin_number.length === 6) {
          this.overlay = true
          let data = {
            'pin_number': this.pin_number,
            'shopId': this.$route.query.shopId,
            'tel': this.tel === null ? this.memberStore.tel : this.tel
          }
          await axios.post(this.DNS_IP + '/member/get-app', data).then(async (result) => {
            if (result.data.status === undefined) {
              // if (this.memberStore) {
              //   this.$router.push('/home?shopId=' + this.shopId)
              // } else {
              this.overlay = false
              this.profile.tel = this.tel
              this.profile.memberId = this.dataMember.memberId
              this.profile.userId = this.dataMember.liffUserId || ''
              this.profile.displayName = this.dataMember.name || this.dataMember.nameCustomer
              this.profile.pictureUrl = this.dataMember.picture || null
              this.profile.memberCardId = this.dataMember.memberCardId || null
              await this.setProfile(this.profile)
              this.$router.push('/')
              // }
            } else {
              this.overlay = false
              this.pin_number = ''
              Swal.fire({
                title: '<h5>' + `${this.$t('message.incorectPin')}` + '</h5>',
                icon: 'error',
                showCancelButton: false,
                allowOutsideClick: false,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#b3b1ab',
                confirmButtonText: `${this.$t('message.confirm')}`
              }).then(async (confirm) => {
                if (confirm.isConfirmed) {
                  // this.profile.tel = this.tel
                  // await this.setProfile(this.profile)
                  // this.$router.push(`/RegisterMember?shopId=${this.$route.query.shopId}&tel=${this.tel}`)
                }
              })
            }
          })
          // console.log('login', this.pin_number)
          // this.profile.tel = this.tel
          // this.profile.memberId = this.dataMember.memberId
          // this.profile.userId = this.thisdataMember.liffUserId || ''
          // this.profile.displayName = this.thisdataMember.name || this.dataMember.nameCustomer
          // this.profile.pictureUrl = this.dataMember.picture || null
          // this.profile.memberCardId = this.dataMember.memberCardId || null
          // await this.setProfile(this.profile)
          // this.$router.push('/home?shopId=' + this.shopId)
        }
      }
    },
    deletePin () {
      this.pin_number = this.pin_number.slice(0, -1)
    },
    async createOtp () {
      const result = await axios.post(this.DNS_IP + `/OTP/resetpin`, {'tel': this.tel.split('-').join('').trim(), 'shopId': this.shopId, 'language': this.$i18n.locale})
      if (result) {
        this.dialogResetOTP = true
      }
    },
    async otpCheck () {
      const data = await axios.get(this.DNS_IP + `/otp/get?tel=${this.tel.split('-').join('').trim()}`)
      if (data.data[0].otpPassword === this.otpPassword) {
        this.dialogResetOTP = false
        this.dialogResetPin = true
      }
    },
    async changeNewPin () {
      try {
        const data = await axios.post(this.DNS_IP + `/member/edit/${this.dataMember.memberId}`, {'pin_number': this.newPinConfirm})
        if (data) {
          Swal.fire({
            title: '<h5>' + `${this.$t('message.changePinSucces')}` + '</h5>',
            text: `${this.$t('message.newPinIs')}` + this.newPinConfirm,
            icon: 'success',
            showCancelButton: false,
            allowOutsideClick: false,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#b3b1ab',
            confirmButtonText: `${this.$t('message.confirm')}`
          }).then(async (confirm) => {
            if (confirm.isConfirmed) {
              this.dialogResetPin = false
              // this.profile.tel = this.tel
              // await this.setProfile(this.profile)
              // this.$router.push(`/RegisterMember?shopId=${this.$route.query.shopId}&tel=${this.tel}`)
            }
          })
        }
      } catch (error) {
        console.error('error', error)
      }
      // console.log(this.dataMember)
      // console.log(this.profile)
    }
  }
}
</script>
<style scoped>
  .swal2-popup {
    font-size: 14px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Login.vue